"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var d3 = _interopRequireWildcard(require("d3"));

var _zip = _interopRequireDefault(require("lodash/zip"));

var _HorizontalTickAxis = _interopRequireDefault(require("./HorizontalTickAxis"));

var _HorizontalAxisTitle = _interopRequireDefault(require("./HorizontalAxisTitle"));

var _AxisLabel = _interopRequireDefault(require("./AxisLabel"));

var _Bar = _interopRequireDefault(require("./Bar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Hover styling done in CSS, remaining styling done in-line for portability (i.e. download or print)
var LabelGroup = _styledComponents.default.g.withConfig({
  displayName: "ButterflyBarChart__LabelGroup",
  componentId: "sc-ft5keb-0"
})(["   &:hover{& text{user-select:none;font-weight:bold;opacity:1.0}& > g:nth-child(2) rect{fill:", ";}& > g:nth-child(3) rect{fill:", ";}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.data.secondary[0];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.data.secondary[3];
});

var LEFT_PADDING = 90;
var RIGHT_PADDING = 12;
var BOTTOM_PADDING = 42;
var DATA_Y_START_PADDING = 20;
var DATA_X_START_PADDING = 25;
var MIDDLE_GAP = 30;
var BAR_HEIGHT = 25;
var BAR_GAP = 12;
var TICK_COUNT = 4;

var VerticalSeparator = function VerticalSeparator(_ref3) {
  var height = _ref3.height;
  return /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#E5E5E5",
    strokeWidth: "5",
    strokeLinecap: "round",
    d: "M0,0 L0,".concat(height)
  });
};

var ButterflyBarChart = /*#__PURE__*/function (_Component) {
  _inherits(ButterflyBarChart, _Component);

  var _super = _createSuper(ButterflyBarChart);

  function ButterflyBarChart() {
    _classCallCheck(this, ButterflyBarChart);

    return _super.apply(this, arguments);
  }

  _createClass(ButterflyBarChart, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          theme = _this$props.theme,
          width = _this$props.width;
      var ids = data.ids,
          labels = data.labels,
          values1 = data.values1,
          values2 = data.values2;
      var yAxisHeight = data.labels.length * (BAR_HEIGHT + BAR_GAP) + 2 * DATA_Y_START_PADDING;
      var xAxisWidth = (width - LEFT_PADDING - MIDDLE_GAP - DATA_X_START_PADDING - RIGHT_PADDING) / 2;
      var height = yAxisHeight + BOTTOM_PADDING; // Text label scale (id -> text label)

      var scaleLabel = d3.scaleOrdinal().range(labels).domain(ids); // Vertical draw scale (id -> y-coordinate)

      var scaleY = d3.scalePoint().range([0, yAxisHeight]).padding(DATA_Y_START_PADDING).domain(ids); // Horizontal draw scale 1 (value -> x-coordinate)

      var maxX = d3.max(values1.concat(values2));
      var scaleX1 = d3.scaleLinear().range([0, xAxisWidth]).domain([0, maxX]).nice(TICK_COUNT); // Horizontal draw scale 2 (value -> x-coordinate)

      var scaleX2 = d3.scaleLinear().range([xAxisWidth, 0]) // Reversed/mirrored horizontally
      .domain([0, maxX]).nice(TICK_COUNT); // Labels

      var yMarkers = scaleY.domain().map(function (id) {
        return /*#__PURE__*/_react.default.createElement(_AxisLabel.default, {
          key: id,
          x: 0,
          y: scaleY(id),
          maxWidth: LEFT_PADDING,
          value: scaleLabel(id)
        });
      }); // Bars

      function generateBars(scaleX, scaleY, values, ids, fill) {
        var originPx = scaleX(d3.min(scaleX.range()));
        var items = (0, _zip.default)(values, ids);
        return items.map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              value = _ref5[0],
              id = _ref5[1];

          return /*#__PURE__*/_react.default.createElement(_Bar.default, {
            key: id,
            value: value,
            x1: originPx,
            x2: scaleX(value),
            y: scaleY(id),
            fill: fill,
            height: BAR_HEIGHT
          });
        });
      }

      var bars1 = generateBars(scaleX2, scaleY, values1, ids, theme.data.primary[0]);
      var bars2 = generateBars(scaleX1, scaleY, values2, ids, theme.data.primary[3]); // Group labels and bars to allow shared hover-styling

      var itemElements = (0, _zip.default)(ids, yMarkers, bars1, bars2);
      var itemGroups = itemElements.map(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 4),
            id = _ref7[0],
            marker = _ref7[1],
            bar1 = _ref7[2],
            bar2 = _ref7[3];

        return /*#__PURE__*/_react.default.createElement(LabelGroup, {
          key: id
        }, /*#__PURE__*/_react.default.createElement("g", null, marker), /*#__PURE__*/_react.default.createElement("g", {
          transform: "translate(".concat(DATA_X_START_PADDING, ", 0)")
        }, bar1), /*#__PURE__*/_react.default.createElement("g", {
          transform: "translate(".concat(DATA_X_START_PADDING + xAxisWidth + MIDDLE_GAP, ", 0)")
        }, bar2));
      }); // Compose SVG element

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height
      }, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(LEFT_PADDING, ", 0)")
      }, itemGroups), /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(LEFT_PADDING + DATA_X_START_PADDING, ", ").concat(yAxisHeight, ")")
      }, /*#__PURE__*/_react.default.createElement(_HorizontalTickAxis.default, {
        scale: scaleX2,
        tickCount: TICK_COUNT
      }), /*#__PURE__*/_react.default.createElement(_HorizontalAxisTitle.default, {
        scale: scaleX2,
        title: "Questions",
        subtitle: "(asked per participant)"
      })), /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(LEFT_PADDING + DATA_X_START_PADDING + xAxisWidth + MIDDLE_GAP, ", ").concat(yAxisHeight, ")")
      }, /*#__PURE__*/_react.default.createElement(_HorizontalTickAxis.default, {
        scale: scaleX1,
        tickCount: TICK_COUNT
      }), /*#__PURE__*/_react.default.createElement(_HorizontalAxisTitle.default, {
        scale: scaleX1,
        title: "Answers",
        subtitle: "(given per participant)"
      })), /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(LEFT_PADDING + DATA_X_START_PADDING + xAxisWidth + MIDDLE_GAP / 2, ", ").concat(DATA_Y_START_PADDING, ")")
      }, /*#__PURE__*/_react.default.createElement(VerticalSeparator, {
        height: yAxisHeight - 2 * DATA_Y_START_PADDING
      }))));
    }
  }]);

  return ButterflyBarChart;
}(_react.Component);

ButterflyBarChart.propTypes = {
  isLoading: _propTypes.default.bool,
  data: _propTypes.default.shape({
    ids: _propTypes.default.arrayOf(_propTypes.default.string),
    labels: _propTypes.default.arrayOf(_propTypes.default.string),
    values1: _propTypes.default.arrayOf(_propTypes.default.number),
    values2: _propTypes.default.arrayOf(_propTypes.default.number)
  })
};
ButterflyBarChart.defaultProps = {
  isLoading: false
};

var _default = (0, _styledComponents.withTheme)(ButterflyBarChart);

exports.default = _default;
//# sourceMappingURL=ButterflyBarChart.js.map